import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkTokenAndRedirect } from '../utils/tokenManager';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check token validity when component mounts
        checkTokenAndRedirect(navigate);
    }, [navigate]);

    return children;
};

export default ProtectedRoute; 